import { render, staticRenderFns } from "./BasicWysiwyg.vue?vue&type=template&id=25b4342a&scoped=true&"
import script from "./BasicWysiwyg.vue?vue&type=script&lang=js&"
export * from "./BasicWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./BasicWysiwyg.vue?vue&type=style&index=0&id=25b4342a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4342a",
  null
  
)

export default component.exports